/**
 * Model Carousel — versiune simpla, sigura.
 * Fiecare model e un link normal catre colectia lui (ex: /collections/genti-amarante).
 * Scriptul de aici se ocupa doar de sagetile de navigare stanga/dreapta;
 * click-ul pe un model navigheaza normal, fara nimic special in JS,
 * deci nu poate intra in conflict cu Boost AI Search & Filter.
 */
(function () {
  'use strict';
 
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
 
    if (prevBtn && track) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -320, behavior: 'smooth' });
      });
    }
    if (nextBtn && track) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: 320, behavior: 'smooth' });
      });
    }
  }
 
  document.querySelectorAll('[data-model-carousel]').forEach(initCarousel);
})();